// removed by extract-text-webpack-plugin
module.exports = {"label":"theme__label___hF3M6","fadeUp":"theme__fadeUp___3w0pc","lateFadeUp":"theme__lateFadeUp___12f4d","lateFadeIn":"theme__lateFadeIn___2ENXA"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Builder/Help/EvidenceExplained/theme.scss
// module id = 1275
// module chunks = 0